import React, { FC, useContext, useEffect, useMemo, useState } from "react";
import Heading from "components/Heading/Heading";
import { DEMO_POSTS } from "data/posts";
import { PostDataType } from "data/types";
import CommentListing from "components/CommentListing/CommentListing";

import { useNavigate, useParams } from "react-router-dom";
//import Input from "shared/Input/Input";
import { requestAPI } from "utils/api";
import CommunityBadge from "components_custom/CommunityBadge/CommunityBadge";
//import PostCardMeta from "./PostCardMeta";

import Input from "shared/Input/Input";

import ButtonCircle from "shared/Button/ButtonCircle";
import { ArrowRightIcon, ArrowSmallLeftIcon, Squares2X2Icon } from "@heroicons/react/24/outline";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import { GlobalDataContext } from "contexts/GlobalData";
import { UIContext } from "contexts/UIContext";

import SigninForm from "components_custom/SigninForm/SigninForm";

import GuestAvatar from "assets/images/guest.png";
import ReservationCard from "./ReservationCard";
import ReservationViewInfo from "./ReservationViewInfo";

//import { ArrowSmallLeftIcon } from "@heroicons/react/24/outline";

// THIS IS DEMO FOR MAIN DEMO
// OTHER DEMO WILL PASS PROPS
const postsDemo: PostDataType[] = DEMO_POSTS.filter((_, i) => i > 7 && i < 14);
//
export interface SectionLatestPostsProps {
  posts?: PostDataType[];
  className?: string;
  postCardName?: "card3";
}


const ReservationView: FC<SectionLatestPostsProps> = ({
  posts = postsDemo,
  postCardName = "card3",
  className = "",
}) => {

	const { id } = useParams();

	const {
		toast,
		modal,
	} = useContext (UIContext);  
	const { 
		initData
	} = useContext (GlobalDataContext);

	const navigate = useNavigate ();

	const [info, setInfo] = useState <any> ({});
	

	useMemo (() => {
		
		(async () => {
			////v1_reserve_var_get
			console.log('DDDDDDDDD')
			const res: any = await requestAPI('GET', `v1/reserve/${id}`, null);

			if(res.code === 1000) {
				setInfo(res.data.info);
			} else {
				navigate('/reservation');		
			}
		})();
	}, []);

	const handleBack = () => {
		navigate(`/reservation`)    
	}

	const handleCancelReservation = async () => {
		const res: any = await requestAPI('DELETE', `v1/reserve/${id}`, {});

		if(res.code === 1000) {
			navigate('/reservation');		
		} else {
			navigate('/reservation');		
		}
	}


	return (
	<>
		    <div className={`container relative nc-SectionLatestPosts overflow-y ${className} h-full bg-white !p-0 lg:w-[768px]`}>
		
			<div className="sticky inset-0 bg-white z-40 flex items-center justify-between">
				<div className="container flex items-center justify-between sm:w-[768px] !p-0 h-[62px]">
					<div className=" top-0 pt-4 pb-4 flex items-center justify-between bg-white">
						<button
							className="focus:outline-none focus:ring-0 w-10 rounded-full flex items-center justify-center hover:bg-neutral-100 ml-2"
							onClick={()=> handleBack()}
						>
							<ArrowSmallLeftIcon className="w-6 h-6" />
						</button>
						{/* <LikeSaveBtns /> */}
						<span
							className="text-xl"
						>
							뒤로
						</span>
					</div>
				</div>
			</div>

			<div className="flex flex-col lg:flex-row">
				<div className="w-full pl-[1rem] pr-[1rem] mb-[10rem]">
					
					<div
						className={`nc-CategoryBadgeList flex items-center flex-wrap space-x-2`}
						data-nc-id="CategoryBadgeList"
					>
						{/* <PostCardMeta
							meta={{
								date: "May 20, 2021",
								author: {
									href: "/home",
									avatar: info.profileUrl,
									displayName: info.user_displayName,
								},
							}}
						/> */}
						{/* <CommunityBadge
							type={info.type}
						/> */}
					</div>

					<div className="flex">
						<h2 className={`text-3xl md:text-4xl font-semibold mt-10`}>
							{info.product_title}
						</h2>
					</div>
						

					<div className="text-neutral-6000 dark:text-neutral-300  mt-10">

						<ReservationCard 
							data={info} 
							buttonSw={false}
						/>

						<div className="mt-10" />

						{

							info.traveler && info.traveler.map ((item: any, idx: number) => (
								<ReservationViewInfo 
									key={`ReservationViewInfo_${idx}`}
									idx={idx}
									productId={id}
									data={item}
								/>
							))	
						}
						
					</div>
					<div className="mt-10">
						<button
							className="w-[200px] text-neutral-50 bg-red-700 hover:bg-red-800 focus:outline-none focus:ring-0 h-10 rounded-full hover:bg-neutral-100"
							onClick={() => handleCancelReservation()}
						>
							예약 취소
						</button>
					</div>
					
				</div>
				
				
			
			</div>
			
		</div>
	</>
	);
};

export default ReservationView;
